import { Link } from "react-router-dom"
import React from "react"

export default function SearchRecomandation(props) {
  return (
    <a href={`/product-details/${props.id}`} >
      <div className="search-recomandation">{props.name}</div>
    </a>
  )
}
